import layout from '../layout/layout';
import ResourcesView from '../Component/Resources/ResourcesView';

const Resources = () => <ResourcesView />;

export default layout(Resources);
